// extracted by mini-css-extract-plugin
export var columnsContainer = "two-column-layout-module--columnsContainer--ecc18";
export var divider = "two-column-layout-module--divider--a96a2";
export var headline = "two-column-layout-module--headline--16f41";
export var headlineContainer = "two-column-layout-module--headlineContainer--4f3fa";
export var layoutL20R80 = "two-column-layout-module--layoutL20R80--3bb1e";
export var layoutL30R70 = "two-column-layout-module--layoutL30R70--a33c4";
export var leftColumn = "two-column-layout-module--leftColumn--005f0";
export var rightColumn = "two-column-layout-module--rightColumn--9d4c5";